(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ccc-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ccc-product-share')) {
    customElements.define('ccc-product-share', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const input = this.querySelector('input');
        const status = this.querySelector('[role="status"]');
        const facebook = this.querySelector('[data-facebook]');
        const twitter = this.querySelector('[data-twitter]');
        const refresh = () => {
          const url = window.location.href;
          input.value = url;
          facebook.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
          twitter.href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(this.dataset.title);
          return url;
        };
        refresh();
        summary.addEventListener('click', async (event) => {
          const url = refresh();
          status.textContent = '';
          if (details.open || !navigator.share) return;
          event.preventDefault();
          try {
            await navigator.share({ title: this.dataset.title, url });
          } catch (error) {
            if (error.name !== 'AbortError') {
              details.open = true;
              this.querySelector('[data-copy]').focus();
            }
          }
        });
        facebook.addEventListener('click', refresh);
        twitter.addEventListener('click', refresh);
        this.querySelector('[data-copy]').addEventListener('click', async () => {
          const url = refresh();
          try {
            await navigator.clipboard.writeText(url);
            status.textContent = this.dataset.copied;
          } catch {
            input.focus();
            input.select();
            status.textContent = this.dataset.manual;
          }
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            details.open = false;
            summary.focus();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
